/* eslint-disable jsx-a11y/anchor-is-valid */
import { Button, CopyIcon, Flex, useMatchBreakpoints, IconButtonV2, Modal, Text } from '@pancakeswap/uikit'
import React, { useState } from 'react'
import { useRouter } from 'next/router'
import styled from 'styled-components'

interface ModalProps {
    title: React.ReactNode
    hideCloseButton?: boolean
    ticketNumber: string
    onBack?: () => void
    onDismiss?: () => void
}

const ModalPaymentOnus: React.FC<React.PropsWithChildren<ModalProps>> = ({ title, ticketNumber, onDismiss }) => {
    const router = useRouter()
    const handleComplete = () => {
        router.push(`/myvoucher`)
        onDismiss()
    }
    const [isTooltipDisplayed, setIsTooltipDisplayed] = useState(false)
    const handleCoppy = () => {
        if (navigator.clipboard && navigator.permissions) {
            navigator.clipboard.writeText(ticketNumber).then(() => displayTooltipCode())
        } else if (document.queryCommandSupported('copy')) {
          const ele = document.createElement('textarea')
          ele.value = ticketNumber
          document.body.appendChild(ele)
          ele.select()
          document.execCommand('copy')
          document.body.removeChild(ele)
          displayTooltipCode()
        }
    }

    function displayTooltipCode() {
        setIsTooltipDisplayed(true)
        setTimeout(() => {
            setIsTooltipDisplayed(false)
        }, 3000)
    }

    const { isMobile } = useMatchBreakpoints()
    return (
        <CsModal title={title} onDismiss={onDismiss}>
            <Flex
                flexDirection="column"
                width="100%"
                style={{ gap: '1rem' }}
                justifyContent="center"
                alignItems="center"
            >
                <img
                    src={`https://wallet.vndc.io/run/tickets/${ticketNumber}/qr-code`}
                    alt="qrcode"
                    style={{ width: '200px', height: '200px' }}
                />
                <CsFlex>
                    <Text fontSize="14px">{ticketNumber}</Text>
                    <CsCopyIcon onClick={handleCoppy}>
                        <CopyIcon />
                        <Tooltip isTooltipDisplayed={isTooltipDisplayed}>Đã sao chép</Tooltip>
                    </CsCopyIcon>
                </CsFlex>
               <Flex flexDirection="column" style={{gap:"1rem"}}>
                    <Button width={isMobile ? "300px" : "350px"} onClick={handleComplete}>
                        Xác nhận thanh toán
                    </Button>
               </Flex>
            </Flex>
        </CsModal>
    )
}

const CsModal = styled(Modal)`
    padding: 24px 0;
    min-width: 470px;
    border-radius: 24px;
    background: #fff;
    box-shadow: 0px 4px 36px 0px rgba(31, 31, 31, 0.1);
    @media screen and(max-width: 1024px) {
        min-width: 300px;
    }
    @media screen and (max-width: 600px) {
        min-width: 90%;
    }
`
export const CsContent = styled(Flex)`
    flex-direction: column;
    width: 100%;
    display: flex;
    gap: 12px;
    border-radius: 12px;
    padding: 0 10px;
    @media screen and (max-width: 768px) {
        padding: 0 15px;
        gap: 4px;
    }
`
export const Row = styled(Flex)`
    flex-direction: row;
    width: 100%;
    display: flex;
    justify-content: space-between;
`
const CsFlex = styled(Flex)`
    width: 350px;
    border-radius: 8px;
    align-items: center;
    justify-content: space-between;
    height: 48px;
    padding: 0px 0px 0px 12px;
    background: #f0f0f0;
    position: relative;
    @media screen and (max-width:600px) {
        width: 300px;
    }
`
const CsCopyIcon = styled(IconButtonV2)`
    border: none;
    height: 48px;
    width: 48px;
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
    background: #E6E9EC;
`
const Tooltip = styled.div<{ isTooltipDisplayed: boolean }>`
    display: ${({ isTooltipDisplayed }) => (isTooltipDisplayed ? "block" : "none")};
    position: absolute;
    top:-34px;
    right: -20px;
    text-align: center;
    color: ${({ theme }) => theme.colors.text};
    border-radius: 16px;
    opacity: 0.9;
    background: ${({theme}) => theme.colors.bgBtn};
    padding: 10px;
    z-index: 1;
    font-size: 12px;
`;

export default ModalPaymentOnus
